import {SERVER, SERVER_DOMAIN} from "../Constants";
import {httpClient} from "../utils/request";
import { stringify } from "query-string";
const apiUrl = SERVER;
const serverUrl = SERVER_DOMAIN;
export function getMany(resource, params){
  switch (resource) {
    case "campaign":
    case "getToKnow":
    case "faqQuestion":
    case "popUpData":
      const queryPopUpData = {
        filter: JSON.stringify({ id: params.id }),
      };
      const urlqueryPopUpData = `${apiUrl}/${resource}?${stringify(queryPopUpData)}`;
      return httpClient(urlqueryPopUpData).then(({ json }) => ({
        data: json.map((resource) => ({
            ...resource,
            id: resource._id,
        })),
      }));
      case "plan":
        
        const querya = {
          filter: JSON.stringify({ id: params.id}),
        };
        const urla = `${apiUrl}/shop/v2/${resource}?${stringify(querya)}`;
        return  httpClient(urla).then(({ json }) => ({ data: json }));

    default:
   
      const query = {
        filter: JSON.stringify({ id: params.ids}),
      };
      const url = `${apiUrl}/${resource}?${stringify(query)}`;
      return  httpClient(url).then(({ json }) => ({ data: json }));
  }
};